import React from 'react';
import { useLayout } from './context';
import { RootieComponent } from './screens/Screen';
import { useScreen } from './screens/screen-provider';

export const Section = ({ id }: { id: string }) => {
  const screen = useScreen();
  const { getSectionById } = useLayout();

  const section = getSectionById(screen?.components?.layout?.id,id);

  if (!section) {
    return <div></div>;
  }

  return (
    <>
      {section.components.map((componentConfig, index) => {
        return <RootieComponent key={index}   component={{...componentConfig}} />;
      })}
    </>
  );
};

const LayoutBase: React.ComponentType<{children: any| any[]}> = (props: {children: any| any[]}) => (
  <div className="layout">
    <header>
      <Section id="header" />
    </header>
    <main>
    {/* <Section id="content" /> */}
      {props?.children || <Section id="content" />}
    </main>
    <footer>
      <Section id="footer" />
    </footer>
  </div>
);

export default LayoutBase;
